// /p/c/:token · /p/app — 옛 「환자 등록 QR」 착지 (2026-10-04 덴클 케어 1차 W5 — 계획_환자앱1차_통합 §2-3)
// 옛 등록 QR(clinicQrTokens, 번호 병합 경로 — 보안 P0)은 서버가 항상 거부하도록 막는다(계획 S2). 그래서 이 화면은 서버를 부르지 않고
//   "더 이상 쓰지 않는 QR" 안내만 한다. 치과 등록은 덴클 케어 앱 안 [치과 QR 찍기]로 데스크 QR을 찍어서 한다.
// 덴클 케어 스토어 링크는 출시 후에만(config/features.careAppStoreLive && config/careApp.js 주소). 그 전에는 링크 없이 데스크 문의 안내.
// 옛 덴클 앱 "앱에서 열기"(dentcluster:// 스킴) 버튼은 뺐다 — 옛 등록 흐름으로 들어가는 길을 남기지 않는다.
// 의료법: 혜택·무료·할인 표현 없음. 사실 안내만.
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getFeatures, isCareSearchLive } from '../../utils/features';
import { CARE_APP_NAME, careStoreLinks, isCareStoreReady } from '../../config/careApp';
import PatientShell from './PatientShell';
import { P } from './patientStyles';

const storeBtn = { ...P.btnSecondary, flex: 1, textAlign: 'center', textDecoration: 'none', padding: '11px 8px', fontSize: 14, boxSizing: 'border-box' };

function PatientQrLanding() {
    const { token } = useParams();
    // 훅은 전부 최상단
    const [storeReady, setStoreReady] = useState(false);
    const [searchLive, setSearchLive] = useState(false);   // 정본 v2.6 §4-2 — 찾기가 운영에서 켜졌을 때만 찾기 포함 문구(기본·조회 실패 = 현행 문구)

    useEffect(() => {
        let alive = true;
        getFeatures().then(f => { if (alive) { setStoreReady(isCareStoreReady(f)); setSearchLive(isCareSearchLive(f)); } })
            .catch(e => console.error('[QR 착지] 플래그 조회 실패:', e?.code || e?.message || e));
        return () => { alive = false; };
    }, []);

    return (
        <PatientShell open>
            <div style={P.card}>
                {token ? (
                    <>
                        <h2 style={P.h2}>더 이상 쓰지 않는 QR입니다</h2>
                        <p style={P.text}>데스크에 문의해 주세요.</p>
                    </>
                ) : (
                    <>
                        <h2 style={P.h2}>{CARE_APP_NAME}</h2>
                        <p style={P.text}>{searchLive
                            ? '치과 등록은 덴클 케어 앱에서 치과 데스크의 QR을 찍거나, 앱의 치과 찾기에서 다니는 치과를 이름이나 주소로 찾아 할 수 있습니다. 찾기에는 덴클 케어 등록을 받는 치과만 나옵니다. 자세한 내용은 데스크에 문의해 주세요.'
                            : '치과 등록은 앱에서 데스크 QR을 찍어 할 수 있습니다. 자세한 내용은 데스크에 문의해 주세요.'}</p>
                    </>
                )}
            </div>

            {storeReady && (
                <div style={{ ...P.card, borderColor: '#c7d2fe', background: '#eef2ff' }}>
                    <h3 style={P.h3}>{`${CARE_APP_NAME} 앱`}</h3>
                    <p style={{ ...P.text, marginBottom: 10 }}>등록한 치과가 맡긴 보철물의 제작 과정과 치과의 안내를 볼 수 있습니다. 앱 등록은 선택이며, 등록하지 않아도 진료는 똑같이 받으실 수 있습니다.</p>
                    <div style={{ display: 'flex', gap: 8 }}>
                        {careStoreLinks().map(l => <a key={l.href} href={l.href} target="_blank" rel="noreferrer" style={storeBtn}>{l.label}</a>)}
                    </div>
                </div>
            )}
        </PatientShell>
    );
}

export default PatientQrLanding;
